// extracted by mini-css-extract-plugin
export default {"body":"proyeccion-fu_body__ellEX"};